import React, { useEffect, useRef } from "react";
import { usePandaDocStatus } from "hooks/usePandaDocStatus";

const PandaDocContainer = ({ pandaDocSessionId, onDocumentCompleted, pandaDocId }) => {
  const iframeRef = useRef(null);
  const containerRef = useRef(null);
  const hasCalledOnCompleted = useRef(false);

  // Reset the guard when the document ID changes
  useEffect(() => {
    hasCalledOnCompleted.current = false;
  }, [pandaDocId]);

  // if panda doc document is already completed, trigger onDocumentComplete state update
  const { data, isLoading, isError } = usePandaDocStatus(pandaDocId);

  useEffect(() => {
    if (!pandaDocId) return;

    if (
      !isLoading &&
      !isError &&
      data?.data?.status === "document.completed" &&
      !hasCalledOnCompleted.current
    ) {
      hasCalledOnCompleted.current = true;
      onDocumentCompleted();
    }
  }, [data, isLoading, isError, onDocumentCompleted, pandaDocId]);


  useEffect(() => {
    if (!pandaDocSessionId) {
      return;
    }

    if (!containerRef.current) {
      return;
    }

    if (iframeRef.current && containerRef.current.contains(iframeRef.current)) {
      containerRef.current.removeChild(iframeRef.current);
      iframeRef.current = null;
    }

    const iframe = document.createElement("iframe");
    iframe.src = `https://app.pandadoc.com/s/${pandaDocSessionId}/`;
    iframe.style.height = "100%";
    iframe.style.width = "100%";
    iframe.style.minHeight = "60vh";
    iframe.style.border = "none";
    iframeRef.current = iframe;
    containerRef.current.appendChild(iframe);

    const handleMessage = (event) => {
      if (
        event &&
        event.data &&
        iframeRef.current &&
        event.source === iframeRef.current.contentWindow
      ) {
        let message = event.data;
        try {
          if (typeof message === "string") {
            try {
              message = JSON.parse(event.data);
            } catch (error) {
              console.error("Error parsing JSON data:", error);
              return;
            }
          }
          if (message && message.event) {
            const event = message.event.replace("embed.form.", "");
            if (event === "session_view.document.completed" && !hasCalledOnCompleted.current) {
              hasCalledOnCompleted.current = true;
              onDocumentCompleted();
            }
          }
        } catch (error) {
          console.error("Error parsing message:", error);
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
      if (iframeRef.current) {
        if (containerRef.current && containerRef.current.contains(iframeRef.current)) {
          containerRef.current.removeChild(iframeRef.current);
        } else if (iframeRef.current.parentNode) {
          iframeRef.current.parentNode.removeChild(iframeRef.current);
        }
      }
      iframeRef.current = null;
    };
  }, [pandaDocSessionId]);

  return <div ref={containerRef} style={{ width: "100%", height: "100%" }}></div>;
};

export default PandaDocContainer;
